module.exports = __webpack_public_path__ + "static/media/myra.a8c5d1bd.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/myra.JPG
// module id = 570
// module chunks = 0